import axios from 'axios';
import url from './Url';

class Company extends url {
    constructor() { super() }

    getCompany = (axiosConfig) => {
        return axios.get(`${this.url()}/company`, axiosConfig)
            .then(response => {
      
                return response;
            })
            .catch(err => {

                if (err.response.status) {
                    localStorage.removeItem('token')
                    window.location.href = '/';
                }
                return err
            });

    }

    editDataCompany = (dadosEditados, axiosConfig) => {
        return axios.put(`${this.url()}/company`, dadosEditados, axiosConfig)
            .then(response => {
                return response;
            })
            .catch(err => {


                return err
            });

    }

    putPasswordInPlataform = (dadosEditados, axiosConfig) => {
        return axios.put(`${this.url()}/company-password`, dadosEditados, axiosConfig)
            .then(response => {
                return response;
            })
            .catch(err => {


                return err
            });

    }

    aditAddressCompany = (finalAddress, axiosConfig) => {
        return axios.put(`${this.url()}/company-address`, finalAddress, axiosConfig)
            .then(response => {
                return response;
            })
            .catch(err => {


                return err
            });
    }

    download = (id, nome) => {
        axios.get(`${this.url()}/download/${id}`, { responseType: "blob" }) // <- Definir responseType: "blob"
            .then((response) => {

                const blob = new Blob([response.data], { type: response.headers["content-type"] });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${nome}`;
                //a.download = `${id}_${nome}`;
                document.body.appendChild(a);
                a.click();
                a.remove();

                window.URL.revokeObjectURL(url);
            })
            .catch((err) => console.error("Erro ao baixar o arquivo:", err));
    };
}

export default Company;
